import { motion } from "framer-motion";
import { LuArrowRight, LuAward, LuFlaskConical, LuHeart } from "react-icons/lu";
import { useLang } from "../i18n";
import { aboutContent } from "../data/content";
import "./About.css";

export default function About() {
  const { t } = useLang();

  return (
    <section id="about" className="about">
      <div className="container about-grid">
        <motion.div
          className="about-copy"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.5 }}
        >
          <span className="section-eyebrow">{t(aboutContent.eyebrow)}</span>
          <h2 className="section-heading">{t(aboutContent.title)}</h2>
          <p className="section-kicker">{t(aboutContent.body)}</p>

          <a
            className="about-award"
            href={aboutContent.awardHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LuAward size={18} aria-hidden />
            <span>{t(aboutContent.award)}</span>
            <LuArrowRight size={14} aria-hidden className="about-award-arrow" />
          </a>

          <a
            href={aboutContent.lundInnovationPortfolio.href}
            className="btn btn-outline about-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(aboutContent.lundInnovationPortfolio.linkLabel)}
            <LuArrowRight size={18} aria-hidden />
          </a>
        </motion.div>

        <motion.div
          className="about-visual"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6 }}
        >
          <div className="about-visual-photo about-visual-logo">
            <img
              src="/img/lu-ventures.png"
              alt={t({
                sv: "LU Ventures — logotyp",
                en: "LU Ventures — logotype",
              })}
              loading="lazy"
            />
          </div>

          <div className="about-badges">
            <div className="about-badge">
              <div className="about-badge-icon">
                <LuFlaskConical size={18} aria-hidden />
              </div>
              <div>
                <strong>
                  {t({
                    sv: "LU Ventures",
                    en: "LU Ventures",
                  })}
                </strong>
                <span>
                  {t({
                    sv: "Forskningsbaserad innovation",
                    en: "Research-based innovation",
                  })}
                </span>
              </div>
            </div>
            <div className="about-badge">
              <div className="about-badge-icon">
                <LuHeart size={18} aria-hidden />
              </div>
              <div>
                <strong>
                  {t({
                    sv: "Vård & patientsäkerhet",
                    en: "Care & patient safety",
                  })}
                </strong>
                <span>
                  {t({
                    sv: "15+ års erfarenhet",
                    en: "15+ years of experience",
                  })}
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
